import { createSelector } from "@reduxjs/toolkit";
export const selectShippingMethods = createSelector([
    (state) => state.freeTrialCart.checkout.shippingMethods,
    (state) => state.checkout.shippingMethods,
    (state) => state.cart.isSubscription,
    (state, isFreeTrial) => isFreeTrial,
], (freeTrialMethods, standardMethods, isSubscription, isFreeTrial) => {
    if (isFreeTrial) {
        return freeTrialMethods;
    }
    const shippingMethods = structuredClone(standardMethods);
    if (isSubscription) {
        const availableShippingMethods = shippingMethods.data.filter(({ disableForSubscription }) => !disableForSubscription);
        const unavailableShippingMethods = shippingMethods.data.filter(({ disableForSubscription }) => disableForSubscription);
        return Object.assign(Object.assign({}, shippingMethods), { data: [...availableShippingMethods, ...unavailableShippingMethods] });
    }
    return shippingMethods;
});
//# sourceMappingURL=selectShippingMethods.js.map